import React, { useEffect, useState } from "react";
import Moment from "moment";

import { Button } from "../ui";

/**
 * Second-step confirmation when marking a part as received.
 * Lets the user set / confirm the date received before persisting.
 */
const SaleMarkPartReceivedModal = ({ open, onClose, onConfirm, loading }) => {
    const [dateReceived, setDateReceived] = useState(() => Moment().format("YYYY-MM-DD"));

    useEffect(() => {
        if (open) {
            setDateReceived(Moment().format("YYYY-MM-DD"));
        }
    }, [open]);

    useEffect(() => {
        if (!open || !onClose) return;
        const onKey = (e) => {
            if (e.key === "Escape" && !loading) onClose();
        };
        window.addEventListener("keydown", onKey);
        return () => window.removeEventListener("keydown", onKey);
    }, [open, onClose, loading]);

    if (!open) return null;

    /**
     * Must render inside DetailModal’s fixed overlay (via topLayer), not portaled to
     * document.body — otherwise global stacking (Bootstrap/MUI/root) can paint this
     * below the part-details shell.
     */
    return (
        <div
            role="dialog"
            aria-modal="true"
            aria-labelledby="mark-received-title"
            className="absolute inset-0 z-20 flex items-center justify-center px-4"
        >
            <button
                type="button"
                aria-label="Close"
                className="absolute inset-0 bg-ink-900 bg-opacity-50"
                onClick={onClose}
            />
            <div className="relative z-10 w-full max-w-md rounded-2xl bg-white p-6 shadow-elevated">
                <h3 id="mark-received-title" className="text-lg font-semibold text-ink-900">
                    Mark as received
                </h3>
                <p className="mt-2 text-sm text-ink-600">
                    Confirm the date this part was received before updating the sale.
                </p>

                <div className="mt-5">
                    <label
                        htmlFor="part-date-received-confirm"
                        className="mb-2 block text-sm font-medium text-ink-700"
                    >
                        Date received
                    </label>
                    <input
                        id="part-date-received-confirm"
                        type="date"
                        value={dateReceived}
                        onChange={(event) => setDateReceived(event.target.value)}
                    />
                </div>

                <div className="mt-6 flex justify-end gap-2">
                    <Button
                        type="button"
                        variant="secondary"
                        size="sm"
                        onClick={onClose}
                        disabled={loading}
                    >
                        Cancel
                    </Button>
                    <Button
                        type="button"
                        variant="primary"
                        size="sm"
                        onClick={() => onConfirm(dateReceived)}
                        disabled={loading || !dateReceived}
                    >
                        {loading ? "Saving..." : "Confirm"}
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default SaleMarkPartReceivedModal;
